// extracted by mini-css-extract-plugin
export default {"Root":"HomePage_Root__92ZjP","Container":"HomePage_Container__BkMMg"};